import script from "./Toolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Toolbar.vue?vue&type=script&setup=true&lang=ts"

import "./Toolbar.vue?vue&type=style&index=0&id=2e82fb97&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e82fb97"]])

export default __exports__